import * as api from '~/api/index';
import * as types from '../types';
import * as userApi from '../api/user';
export const state = () => {
  return {
    hotArticle: null,
    dtbList: null,
    purDtbList: null,
    locales: ['zh-cn', 'zh-hk'],
    locale: 'zh-cn',
    advertisement: {
      indexBanner: null,
      detailfooterBanner: null,
      indexTopOperation: null,
      indexBottomOperation: null
    }
  };
};

export const mutations = {
  getHotArticle(state, hotArticle) {
    state.hotArticle = hotArticle;
  },
  getDtbList(state, dtbList) {
    state.dtbList = dtbList;
  },
  getpureDtbList(state, purDtbList) {
    state.purDtbList = purDtbList;
  },
  SET_LANG(state, locale) {
    if (state.locales.indexOf(locale) !== -1) {
      state.locale = locale;
    }
  },
  // TODO: 这里定义一个方法去处理登陆状态，理论上这个是多余的，应该用user.js的方法，待优化
  SERVER_ISLOGIN(state, data) {
    state.user.isLogin = data;
  },
  [types.INIT_ADVERTISEMENT](state, data) {
    if (!data) return;
    state.advertisement = data && data.data ? data.data : null;
  }
};

export const actions = {
  async nuxtServerInit({ commit }, { app, req, $axios, store }) {
    const headers = req && req.headers;
    let loginStatus = await $axios(userApi.getLoginStatus(headers));
    if (loginStatus.statusCode === 200) {
      commit(types.SERVER_ISLOGIN, true);
      // commit(types.LOGIN_LOCAL);
    } else {
      commit(types.SERVER_ISLOGIN, false);
    }

    let dayChartResult = await $axios(api.getHotArticle('dayChart'));
    let weekChartResult = await $axios(api.getHotArticle('weekChart'));
    let dtbListResult = await $axios(
      api.getDtbList({
        liveChannelId: 'all',
        limit: 20
      })
    );
    let infiniteDetailResult = await $axios(
      api.infidtbList({
        liveChannelId: 'all',
        limit: 20
      })
    );
    let advertisement = await $axios(api.getAdvertisement());

    // console.log(dayChartResult)
    commit(
      'getpureDtbList',
      infiniteDetailResult &&
        infiniteDetailResult.result &&
        infiniteDetailResult.result.length > 0
        ? infiniteDetailResult.result
        : []
    );
    commit('getHotArticle', [
      dayChartResult &&
      dayChartResult.result &&
      dayChartResult.result.length > 0
        ? dayChartResult.result
        : [],
      weekChartResult &&
      weekChartResult.result &&
      weekChartResult.result.length > 0
        ? weekChartResult.result
        : []
    ]);
    commit(
      'getDtbList',
      dtbListResult && dtbListResult.result && dtbListResult.result.length > 0
        ? dtbListResult.result
        : []
    );

    commit(types.INIT_ADVERTISEMENT, advertisement);
  }
};
